module.exports = __webpack_public_path__ + "img/close.54a49133.svg";